import type { JSX } from "react";
import type { CompareBlock as CompareBlockModel } from "@shared/types";
import type { BlockRendererProps } from "./registry";

/**
 * Compare-block renderer (Feature 3, Lane 1): an option-comparison table that
 * highlights the recommended option, instead of a model-authored markdown table.
 * Cells are index-aligned to the options. Themed from design-system tokens.
 */
export function CompareBlockView({ block }: BlockRendererProps): JSX.Element {
  const cmp = block as CompareBlockModel;
  const recIdx = cmp.options.findIndex((o) => o.recommended === true);
  return (
    <div className="compare-block">
      {cmp.title !== undefined && cmp.title.length > 0 && (
        <div className="compare-title">{cmp.title}</div>
      )}
      <div className="compare-scroll">
        <table className="compare-table">
          <thead>
            <tr>
              <th className="compare-corner" />
              {cmp.options.map((o, i) => (
                <th key={o.id} className={i === recIdx ? "compare-col-rec" : undefined}>
                  <span className="compare-opt-name">{o.name}</span>
                  {i === recIdx && <span className="compare-rec-tag">推荐</span>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cmp.rows.map((row, ri) => (
              <tr key={ri}>
                <th scope="row" className="compare-row-label">
                  {row.label}
                </th>
                {cmp.options.map((o, ci) => {
                  const cell = row.cells[ci];
                  return (
                    <td key={o.id} className={ci === recIdx ? "compare-col-rec" : undefined}>
                      {cell !== undefined && cell.length > 0 ? cell : "—"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {cmp.recommendation !== undefined && cmp.recommendation.length > 0 && (
        <div className="compare-rec-note">
          <span className="compare-rec-note-label">推荐</span>
          {cmp.recommendation}
        </div>
      )}
    </div>
  );
}
